import { createFileRoute } from '@tanstack/react-router';
import { withModalOutlet } from '../-withModalOutlet';
import UserGroups from '../../../administration/src/components/Apps/AppDetails/Permissions/UserGroups';

export const Route = createFileRoute('/_secured/administration/apps/$appId/permissions/user-groups/$page/$limit')({
  component: withModalOutlet(UserGroups),
});
